import { CloudinaryContext } from "cloudinary-react"
import { withRouter } from "react-router"
import PageWrapper from "~/components/Common/PageWrapper"
import Snackbar from "~/components/Snackbar"
import Interceptor from "~/components/interceptor"
import { AppContainer } from "~/contexts/App"
import { InstructorsContainer } from "~/contexts/Instructors"
import { UsersContainer } from "~/contexts/Users"
import AddKeysToClientsDialog from "~/dialogs/AddKeysToClientsDialog"
import ConfirmPassword from "~/dialogs/ConfirmPassword"
import ConfirmationClickDialog from "~/dialogs/ConfirmationClickDialog"
import ConfirmationTypingDialog from "~/dialogs/ConfirmationTypingDialog"
import CoursesAttachedToLessonDialog from "~/dialogs/CoursesAttachedToLessonDialog"
import CreateAdminDialog from "~/dialogs/CreateAdmin"
import CreateAppUserDialog from "~/dialogs/CreateAppUserDialog"
import CreateCategoryDialog from "~/dialogs/CreateCategoryDialog"
import CreateCertificationDialog from "~/dialogs/CreateCertificationDialog"
import CreateClientDialog from "~/dialogs/CreateClientDialog"
import CreateCourseLessonDialog from "~/dialogs/CreateCourseLessonDialog"
import CreateDiscountDialog from "~/dialogs/CreateDiscountDialog"
import CreateInstanceDialog from "~/dialogs/CreateInstanceDialog"
import CreateInstructorDialog from "~/dialogs/CreateInstructorDialog"
import CreateLearningPathDialog from "~/dialogs/CreateLearningPathDialog"
import CreateNewVersionDialog from "~/dialogs/CreateNewVersionDialog"
import CreateTabDialog from "~/dialogs/CreateTabDialog"
import CropThumbnailDialog from "~/dialogs/CropThumbnailDialog"
import DeleteImageDialog from "~/dialogs/DeleteImageDialog"
import EditClientKeysDialog from "~/dialogs/EditClientKeysDialog"
import EditInstanceDialog from "~/dialogs/EditInstanceDialog"
import EditInstructorDialog from "~/dialogs/EditInstructorDialog"
import EditLabOutputDialog from "~/dialogs/EditLabOutputDialog"
import EditResourceDialog from "~/dialogs/EditResourceDialog"
import EditUserDialog from "~/dialogs/EditUserDialog"
import HistoryVersionDialog from "~/dialogs/HistoryVersionDialog"
import InstructorListDialog from "~/dialogs/InstructorListDialog"
import MyAccountDialog from "~/dialogs/MyAccount"
import PermissionsDialog from "~/dialogs/PermissionsDialog"
import ResetCourseProgress from "~/dialogs/ResetCourseProgress"
import SimpleConfirmDialog from "~/dialogs/SimpleConfirmDialog"
import UnsavedDataDialog from "~/dialogs/UnsavedDataDialog"
import UserDetailsDialog from "~/dialogs/UserDetailsDialog"
import ViewInstructorDialog from "~/dialogs/ViewInstructorDialog"
import CreateCopyDialog from "~/dialogs/createCopyDialog"
import Router, { routeConfig } from "~/router"
import { Toaster } from "~/v2/components/ui/sonner"

import useStyles from "./styles"

const App = () => {
  const { classes } = useStyles()

  return (
    <AppContainer>
      <InstructorsContainer>
        <UsersContainer>
          <PageWrapper>
            <CloudinaryContext
              style={{ height: "100%" }}
              cloudName={import.meta.env.VITE_CLOUDINARY_CLOUD_NAME}
            >
              <Router routes={routeConfig} />
            </CloudinaryContext>
          </PageWrapper>
          <div id="dialog-holder">
            {/* LEAVE THIS IN PLACE FOR DIALOGS TO POPULATE INTO */}
            <MyAccountDialog />
            <CreateCourseLessonDialog />
            <CreateInstructorDialog />
            <CreateCategoryDialog />
            <CreateClientDialog />
            <CreateAdminDialog />
            <ConfirmPassword />
            <ConfirmationTypingDialog />
            <UserDetailsDialog />
            <EditUserDialog />
            <HistoryVersionDialog />
            <CoursesAttachedToLessonDialog />
            <EditResourceDialog />
            <EditInstructorDialog />
            <InstructorListDialog />
            <ViewInstructorDialog />
            <ConfirmationClickDialog />
            <CropThumbnailDialog />
            <DeleteImageDialog />
            <UnsavedDataDialog />
            <CreateDiscountDialog />
            <CreateNewVersionDialog />
            <CreateCopyDialog />
            <CreateLearningPathDialog />
            <PermissionsDialog />
            <SimpleConfirmDialog />
            <CreateCertificationDialog />
            <CreateAppUserDialog />
            <ResetCourseProgress />
            <EditInstanceDialog />
            <EditLabOutputDialog />
            <CreateInstanceDialog />
            <CreateTabDialog />
            <EditClientKeysDialog />
            <AddKeysToClientsDialog />
          </div>
          <Toaster closeButton />
          <Snackbar />
          <Interceptor />
        </UsersContainer>
      </InstructorsContainer>
    </AppContainer>
  )
}

export default withRouter(App)
